// ======================================================================
// FILE:
// src/modules/expense_management/claims/pages/ExpenseClaimViewPage.jsx
//
// MODULE:
// Expense Management
//
// FEATURE:
// View Expense Claim
// ======================================================================

import React, {
  useEffect,
  useState,
} from "react";

import {
  useParams,
} from "react-router-dom";

import expenseClaimService
from "../services/expenseClaimService";

import businessReferenceService
from "../services/businessReferenceService";

import ExpenseClaimHeader
from "../components/ExpenseClaimHeader";

import ExpenseItemsGrid
from "../components/ExpenseItemsGrid";

import BusinessReferenceCard
from "../components/BusinessReferenceCard";

export default function ExpenseClaimViewPage() {

  const { id } =
    useParams();

  const [loading, setLoading] =
    useState(true);

  const [claim, setClaim] =
    useState(null);

  const [items, setItems] =
    useState([]);

  const [attachments, setAttachments] =
    useState([]);

  const [comments, setComments] =
    useState([]);

  const [history, setHistory] =
    useState([]);

  const [approvalTimeline, setApprovalTimeline] =
  useState([]);

  // ==========================================================
  // LOAD
  // ==========================================================

  useEffect(() => {

    loadData();

  }, [id]);

  async function loadData() {

    try {

      setLoading(true);

      const [

        claim,

        items,

        attachments,

        comments,

        history,

        approvalTimeline

      ] = await Promise.all([

        expenseClaimService.getExpenseClaim(id),

        expenseClaimService.getExpenseClaimItems(id),

        expenseClaimService.getExpenseAttachments(id),

        expenseClaimService.getExpenseComments(id),

        expenseClaimService.getExpenseHistory(id),

        expenseClaimService.getApprovalTimeline(id),

      ]);

      let claimData = claim;

      if (

          claim?.reference_id &&

          claim?.expense_source &&

          claim?.reference_type

      ) {

          try {

              const details =
                  await businessReferenceService
                      .getBusinessReferenceDetails(

                          claim.reference_id,

                          claim.expense_source,

                          claim.reference_type

                      );

              claimData = {

                  ...claim,

                  ...details,

              };

          }

          catch (error) {

              console.error(

                  "Unable to load Business Reference Details",

                  error

              );

          }

      }

      setClaim(
          claimData
      );

      setItems(

    items.map((item) => ({

        ...item,

        id: item.expense_claim_item_id,

        isEditing: false,

    }))

);

      setAttachments(
        attachments
      );

      setComments(
        comments
      );

      setHistory(
        history
      );

      setApprovalTimeline(
        approvalTimeline
      );
    }

    catch (error) {

      console.error(error);

      alert(

        error?.response?.data?.message ||

        "Unable to load Expense Claim."

      );

    }

    finally {

      setLoading(false);

    }

  }

  // ==========================================================
  // RENDER
  // ==========================================================

  return (

    <div className="container-fluid">

      <div
        className="card border-0 mb-4"
        style={{
          background:
            "linear-gradient(90deg,#0d6efd,#4f8cff)",
          borderRadius: 12,
          color: "#fff",
        }}
      >

        <div className="card-body">

          <h2>

            View Expense Claim

          </h2>

          <div>

            Expense Claim Details

          </div>

        </div>

      </div>

      {

        loading &&

        <div className="text-center py-5">

          <div className="spinner-border text-primary"/>

        </div>

      }

      {

        !loading &&

        <>

          <ExpenseClaimHeader
            data={claim}
            readOnly={true}
          />
          <BusinessReferenceCard
              data={claim}
              readOnly={true}
          />

            <ExpenseItemsGrid

                rows={items}

                onChange={setItems}

                readOnly={true}

            />

          <div className="card mb-3">

            <div className="card-header">

              Attachments

            </div>

            <div className="card-body">

              <pre>

                {JSON.stringify(
                  attachments,
                  null,
                  2
                )}

              </pre>

            </div>

          </div>

          <div className="card mb-3">

            <div className="card-header">

              Comments

            </div>

            <div className="card-body">

              <pre>

                {JSON.stringify(
                  comments,
                  null,
                  2
                )}

              </pre>

            </div>

          </div>

          <div className="card">

            <div className="card-header">

              History

            </div>

            <div className="card-body">

              <pre>

                {JSON.stringify(
                  history,
                  null,
                  2
                )}

              </pre>

            </div>

          </div>
          <div className="card mt-3">

            <div className="card-header">

              Approval Timeline

            </div>

            <div className="card-body">

              <pre>

                {JSON.stringify(
                  approvalTimeline,
                  null,
                  2
                )}

              </pre>

            </div>

          </div>

        </>

      }

    </div>

  );

}